<script>
export default {
  components: { },
  props: {
    report: {
      type: Object,
      required: true
    }
  }
}
</script>
<template>
  <div>
    <h1>{{ $t('overview.heading') }}</h1>
    <h3><BaseDate :date="report.from_date" /> - <BaseDate :date="report.to_date" /></h3>
    <ul :class="$style.placeList">
      <li>{{ $t('overview.businesses_included') }} </li>
      <li v-for="place in report.data.places" :key="place.id">
        <a :href="place.url" target="_blank">{{ place.name }}</a>
      </li>
    </ul>
  </div>
</template>
<style lang="scss" module>
@import '@design';
.placeList {
  li {
    display: inline-block;
    &:not(:last-child):not(:first-child):after {
      content: ", ";
      display: inline-block;
    }
    a {
      color: $color-text;
      &:hover {
        color: $color-link-text;
      }
    }
  }
}
</style>
